import { render, staticRenderFns } from "./NewImage.vue?vue&type=template&id=3a97a548&scoped=true"
import script from "./NewImage.vue?vue&type=script&lang=js"
export * from "./NewImage.vue?vue&type=script&lang=js"
import style0 from "./NewImage.vue?vue&type=style&index=0&id=3a97a548&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a97a548",
  null
  
)

export default component.exports